import { WithAvailabilityBlockId, WithServiceId } from '@mews-commander/types';
import { useBookingEngineLinkEnabled } from '../../utils/useBookingEngineLinkEnabled';
import { BookingEngineLinkUpselling } from './BookingEngineLinkUpselling';
import { BookingEngineLink } from './BookingEngineLink';

interface BookingEngineLinkWrapperProps extends WithAvailabilityBlockId, WithServiceId {
    startUtc: string;
    endUtc: string;
}

export const BookingEngineLinkWrapper: React.FC<BookingEngineLinkWrapperProps> = ({
    availabilityBlockId,
    serviceId,
    startUtc,
    endUtc,
}) => {
    const bookingEngineLinkEnabled = useBookingEngineLinkEnabled();

    return bookingEngineLinkEnabled ? (
        <BookingEngineLink
            availabilityBlockId={availabilityBlockId}
            serviceId={serviceId}
            startUtc={startUtc}
            endUtc={endUtc}
        />
    ) : (
        <BookingEngineLinkUpselling />
    );
};
